import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=3ae842ee&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=3ae842ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae842ee",
  null
  
)

export default component.exports